import { useState } from "react";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import { makeStyles } from "tss-react/mui";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ datePicker: { fontSize: "0.8rem" } }); });
export var dateFormat = "YYYY-MM-DD";
export function DateCell(props) { var date = useState(moment(props.value || undefined))[0]; var styles = useStyles().classes; return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(DatePicker, { open: true, onClose: function () { return props.onCancel(); }, className: styles.datePicker, format: dateFormat, value: date, formatDensity: "dense", onChange: function (e) { if (e == null)
            return; props.onChange(e.startOf("day").toJSON(), { tab: 1 }); } }) }); }
